import { Alert, Snackbar, lighten } from '@mui/material';

import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  message: string;
  position?: 'top' | 'bottom';

  handleClose(): void;
}

const PaiSuccessAlert: React.FC<Props> = ({ open, message, position = 'top', handleClose }) => {
  const { classes } = useStyles();

  return (
    <Snackbar open={open} autoHideDuration={5000} anchorOrigin={{ vertical: position, horizontal: 'center' }} onClose={handleClose} message={message}>
      <Alert className={classes.alert} onClose={handleClose} severity="success" variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

const useStyles = makeStyles()((theme) => ({
  alert: {
    zIndex: 1500,
    background: lighten(theme.palette.success.main, 0.8),
  },
}));

export default PaiSuccessAlert;
